import axios from "axios";
import API from "../helpers/api";
import FileSaver from 'file-saver';

export const getClientShipCount = (contract,both) => {
    let user = JSON.parse(localStorage.getItem("currentUser"));
    let url = `${API.MMPLShipCount}?mail=${user.email}&inContract=${contract}&isBoth=${both}`;
    return dispatch => {
        axios.get(url)
            .then((response) => {
                dispatch({
                    type: "getClientShipCountSuccess",
                    data: response.data,
                })
            })
            .catch((error) => {
                dispatch({
                    type: "getClientShipCountFailure",
                    error: "ERROR"
                })
            })
    }
}

export const getClientSearchlist = (searchItem, PgNo) => {
    let url = `${API.ClientShipSearch}?ShipName=${searchItem.mDocShipName}&TaskType=${searchItem.TaskType}&PageNumber=${PgNo}&PageSize=${searchItem.PgSize}`;
    return dispatch => {
        axios.get(url)
            .then((response) => {
                dispatch({
                    type: "GetClientSearchSuccess",
                    data: response.data,
                })
            })
            .catch((error) => {
                dispatch({
                    type: "GetClientSearchFailure",
                    error: "ERROR"
                })
            })
    }
}


export const getClientShipDetails = (item) => {
    let ClientShipDetails = [
        {
            "clientId": 1,
            "shipId": 1,
            "equipmentId": 1,
            "ShipEquipmentId": 1,
            "equipmentServiceId": 1,
            "AttachmentId": 1,
            "shipName": "Qantler",
            "AttachmentName": "aaa.pdf",
            "AttachmentGuid": "maddfadweaad23qedwad1d",
            "totalEquipment": 100,
            "overDue": 50,
            "dueIn30Days ": 50,
            "dueIn90Days ": 50,
            "createdBy": "gg",
            "createdDate": "2000-01-01",
            "modifiedBy": "gg",
            "modifiedDate": "2000-01-01"
        },
        {
            "clientId": 2,
            "shipId": 3,
            "equipmentId": 1,
            "ShipEquipmentId": 1,
            "equipmentServiceId": 1,
            "AttachmentId": 1,
            "shipName": "Qantler",
            "AttachmentName": "aaa.pdf",
            "AttachmentGuid": "maddfadweaad23qedwad1d",
            "totalEquipment": 100,
            "overDue": 50,
            "dueIn30Days ": 50,
            "dueIn90Days ": 50,
            "createdBy": "gg",
            "createdDate": "2000-01-01",
            "modifiedBy": "gg",
            "modifiedDate": "2000-01-01"
        }
    ]
    // let url = `${API.getShips}?shipname=${item.shipName}&nextduetype=${item.ServiceType}&nextduefromdate=${item.nextDueFromDate}&nextduetodate=${item.nextDueToDate}&pagenumber=${item.pagenumber}`;
    return dispatch => {
        //     axios.get(url)
        //         .then((response) => {
        dispatch({
            type: "getClientShipDetailSuccess",
            data: ClientShipDetails,
        })
        // })
        // .catch((error) => {
        //     dispatch({
        //         type: "getClientShipDetailFailure",
        //         error: "ERROR"
        //     })
        // })
    }
}
export const DownloadShipDetails = (item) => {
    let url = `${API.clientStatus}?filename=${item.FileName}&guid=${item.Guid}`;
    return dispatch => {
        axios.get(url, { responseType: "blob" })
            .then((response) => {
                let blob = '';
                blob = new Blob([response.data], { type: response.data.type });
                var mime = require('mime-types'),
                fileExtension = mime.extension(response.data.type)
                FileSaver.saveAs(blob, item.FileName+"."+fileExtension);
            })
            .catch((error) => {
                dispatch({
                    type: "DownloadStatusFailure",
                    error: "ERROR"
                })
            })
    }
}